export const LINKS = {
  CENTER_AI: 'https://center.ai/',
};
